import { Component, Input, Output, EventEmitter } from '@angular/core';

import { Global } from '../../../../../app.global';
import { Constants } from '../../../helper/constants';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'multiple-select-question',
  templateUrl: './multiple-select-question.component.html',
})
export class MultipleSelectQuestionComponent {
  @Input() data: { questions: Array<object> };
  @Input() valuesSelected: any;
  @Input() active: boolean;
  @Output() selectAnswer: EventEmitter<any> = new EventEmitter<any>();

  constants = Constants;

  constructor(public global: Global) {}

  isOptionSelected(questionId, answerId) {
    let bool = false;
    this.valuesSelected.forEach((selectedValue) => {
      if (selectedValue.id === questionId && selectedValue.value === answerId) {
        bool = true;
      }
    });
    return bool;
  }

  onMultipleSelectQuestionTestSelected(questionId, value) {
    if (!this.active) {
      return;
    }
    const newValuesSelected = [];
    this.valuesSelected.forEach((selectedValue) => {
      if (selectedValue.id === questionId) {
        selectedValue.value = value;
      }
      newValuesSelected.push(selectedValue);
    });
    this.selectAnswer.emit(newValuesSelected);
  }
}
